export default "__VITE_ASSET__7c27bfa9__"